import React from "react";
import { Field } from "react-final-form";

export default ({ when, is, isNot, test, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {
      ({ input: { value } }) => {
        if ((is && value === is) || (isNot && value !== isNot) || (typeof test === 'function' && test(value))) {
          return children
        }
        return null
      }
    }
  </Field>
);